import { useState } from 'react'
import { useDebouncedValue } from './useDebouncedValue'

export function useThreadsSearchControls() {
  const [searchValue, setSearchValue] = useState('')
  const [filter, setFilter] = useState('all')
  const debouncedQ = useDebouncedValue(searchValue)
  return { searchValue, setSearchValue, filter, setFilter, debouncedQ }
}
